export default __webpack_public_path__ + "static/media/medical.25e24f80.jpg";